import axios from "axios";

export const state = {
    reportsavingpermembers: [],
};

export const getters = {
    reportsavingpermembers: state => state.reportsavingpermembers,
};

export const mutations = {
    setReportSavingsPerMember(reportsavingpermembers, newValue) { state.reportsavingpermembers = newValue},
};

export const actions = {
    async fetchReportSavingsPerMember({ commit }) {
        await axios.get('/reportsavingpermembers').then(res => {
            commit('setReportSavingsPerMember', res.data.savings)
        })
    },
    async filterReportSavingsPerMember({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportsavingpermembers";
        await axios.post(url, formData).then((response) => {
            commit('setReportSavingsPerMember', response.data.savings)
        })
    },
};
